var map = {
	"./angpao.webp": 2312,
	"./bonus.webp": 2313,
	"./gpi-rebate-m.webp": 2314,
	"./gpi-rebate.webp": 2315,
	"./hublot-watch-2018.webp": 2316,
	"./hublot-watch-2022.webp": 2317,
	"./iphone-13-pro-max.webp": 2318,
	"./iphone-14-pro-max.webp": 2319,
	"./login-to-m.webp": 2320,
	"./login-to.webp": 2321,
	"./mb.webp": 2322,
	"./mg-rebate-m.webp": 2323,
	"./mg-rebate.webp": 2324,
	"./np.webp": 2325,
	"./pointer.webp": 2326,
	"./pp-rebate-m.webp": 2327,
	"./pp-rebate.webp": 2328,
	"./sadface.webp": 2329,
	"./wallet-m.webp": 2330,
	"./wallet.webp": 2331,
	"./wheel-b.webp": 2332,
	"./wheel-btn.webp": 2333,
	"./wheel-indon-b.webp": 2334,
	"./wheel-indon.webp": 2335,
	"./wheel.webp": 2336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 926;